import "./MetricCard.css";
import { ReactNode } from "react";

interface MetricCardProps {
    title: string;
    children: ReactNode;
    width?: string;
    height?: string;
    accentColor?: string;
    loading?: boolean;
    error?: string;
}

export function MetricCard({ title, children, width, height, accentColor, loading, error }: MetricCardProps) {
    const isLargeCard = height && parseInt(height) > 300;
    
    return (
        <div className="metric-card" style={{ width, height }}>
            {accentColor && <div className="metric-card-accent" style={{ backgroundColor: accentColor }} />}
            <div className="metric-card-header">
                <span className="metric-card-title">{title}</span>
            </div>
            <div className="metric-card-content" style={{ display: 'flex', flexDirection: 'column', height: isLargeCard ? 'calc(100% - 50px)' : 'auto' }}>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, padding: '40px 0' }}>
                        <div className="chart-loader"></div>
                    </div>
                ) : error ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, padding: '40px 20px', color: '#ef4444', textAlign: 'center' }}>
                        {error}
                    </div>
                ) : (
                    children
                )}
            </div>
        </div>
    );
}
